module.exports = __webpack_public_path__ + "static/media/anage-imoveis-imobiliaria-joinville.934fc0d0.webp";